import { ConditionalRender, Stack } from '@crossnokaye/ux-common';

import { DisplayRef } from '@repo/sdk/models/components';

import { SidebarAccordionItem } from '@/components/templates/sidebar-accordion-template';
import { SelectionsDevice } from '@/features/clickhouse-trends/components/selections-sidebar/selections.types';
import { useAttributeSelection } from '@/features/clickhouse-trends/state/hooks/use-attribute-selection';
import { Checkbox } from '@/ux-common/components/checkbox/checkbox';

import { EmptyDeviceAttributeList } from './empty-device-attribute-list';

type DeviceAttributeCheckboxListProps = {
  item: SidebarAccordionItem<SelectionsDevice>;
};

export const DeviceAttributeCheckboxList = ({ item }: DeviceAttributeCheckboxListProps) => {
  const { toggleAttributeAction, hasAttribute } = useAttributeSelection();

  const getAttribute = (displayRef: DisplayRef) => ({
    deviceId: item.data.deviceId,
    displayRef: displayRef,
    displayName: item.data.displayName,
  });

  return (
    <Stack className="pl-8 pr-4 py-2" gap="thin">
      {item.data.displayRefs.map((displayRef) => (
        <Checkbox
          key={`point-${displayRef.ref.id}`}
          checked={hasAttribute(getAttribute(displayRef))}
          onCheckedChange={() => toggleAttributeAction(getAttribute(displayRef))}
          label={displayRef.label}
        />
      ))}
      <ConditionalRender condition={!item.data.displayRefs || item.data.displayRefs?.length === 0}>
        <EmptyDeviceAttributeList />
      </ConditionalRender>
    </Stack>
  );
};
